export default __webpack_public_path__ + "static/media/8.57638ad3.jpg";